export const HOSTNAME = window?.location?.hostname;

export const IS_PROD = HOSTNAME === 'route.mezzoforte.design';

export const APP_NAME = 'agami-route';
